import axios from 'axios'
import globalVar from './GlobalVar.js'
// import jsonData from '../public/config.json'
//import jsonData from '../public/config.json'

// const apiClient = axios.create({
//   //baseURL: 'https://postchat.us/api/', //public
//   //baseURL: 'http://test.postchat.us/api/', //test
//   //baseURL: 'https://pctest.mpos.us/api/',
//   //baseURL: 'http://192.168.0.5:56910/api/',
//   //baseURL: 'http://localhost:56910/api/',
//   //baseURL: jsonData.baseURL,
//   withCredentials: false,
//   //transformRequest: [data => JSON.stringify(data.data)],
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })
//console.log(jsonData.baseURL)

export default {
  data: function() {
    return {
      configData: []
    }
  },
  request(url, parameter) {
    let para = JSON.stringify(parameter)

    // get Config JS
    // if (sessionStorage.getItem('configData')) {
    //   const value = JSON.parse(sessionStorage.getItem('configData'))
    //   //console.log('config Data: ', value)

    //   const apiClient = axios.create({
    //     baseURL: value.baseURLApi,
    //     withCredentials: false,
    //     //transformRequest: [data => JSON.stringify(data.data)],
    //     headers: {
    //       'Content-Type': 'application/json'
    //     }
    //   })
    //   //apiClient.baseURL = value.baseURL
    //   return apiClient.post(url, para)
    // }

    // Hard Code
    var apiClient
    if (globalVar.mode == 'normal') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://pctest.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://postchat.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      }
    } else if (globalVar.mode == 'lite') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://testapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://orderapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'application/json'
          }
        })
      }
    }

    //apiClient.baseURL = value.baseURL
    return apiClient.post(url, para)
  },

  multipart(url, parameter, fileList, val) {
    let formData = new FormData()
    let para = JSON.stringify(parameter)
    formData.append('JsonData', para)
    // for (var i = 0; i < fileList.length; i++) {
    //   formData.append('File', fileList[i].file)
    // }
    //console.log(fileList)
    if (val == 'menuImg') {
      if (fileList != []) {
        formData.append('TN', fileList[0].file)
        formData.append('FS', fileList[1].file)
      }
    } else if (val == 'mchtConfig') {
      if (fileList != []) {
        formData.append('logo', fileList[0].file)
        formData.append('banner', fileList[1].file)
      }
    }

    // get Config JS
    //console.log(formData)
    // if (sessionStorage.getItem('configData')) {
    //   const value = JSON.parse(sessionStorage.getItem('configData'))
    //   //console.log('config Data: ', value)

    //   const apiClient = axios.create({
    //     baseURL: value.baseURLApi,
    //     withCredentials: false,
    //     //transformRequest: [data => JSON.stringify(data.data)],
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   })
    //   //apiClient.baseURL = value.baseURL
    //   return apiClient.post(url, formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     }
    //   })
    // }

    // Hard Code
    var apiClient
    if (globalVar.mode == 'normal') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://pctest.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://postchat.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }
    } else if (globalVar.mode == 'lite') {
      if (globalVar.state == 'test') {
        apiClient = axios.create({
          baseURL: 'https://testapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      } else if (globalVar.state == 'live') {
        apiClient = axios.create({
          baseURL: 'https://orderapi.mpos.us/api/',
          withCredentials: false,
          //transformRequest: [data => JSON.stringify(data.data)],
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }
    }
    //apiClient.baseURL = value.baseURL
    return apiClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  checkImg(img) {
    if (img.startsWith('http')) {
      return img
    } else {
      const value = 'https://image.mpos.us/'
      return value + img
    }
  },
  setToZero(val) {
    if (val == '' || val == undefined || val == null) {
      return 0
    } else {
      return val
    }
  },
  IsJsonString(item) {
    item = typeof item !== 'string' ? JSON.stringify(item) : item

    try {
      item = JSON.parse(item)
    } catch (e) {
      return false
    }

    if (typeof item === 'object' && item !== null) {
      return true
    }

    return false
  }
  // getConfig() {
  //   let self = this
  //   fetch('config.json')
  //     .then(res => {
  //       return res.json()
  //     })
  //     .then(
  //       json => {
  //         self.configData = JSON.stringify(json)
  //         console.log('getJsonData.json : ' + self.configData)
  //         sessionStorage.setItem('configData', self.configData)
  //         return JSON.stringify(json)
  //       }
  //     )
  // }
}
